/**
 * Takes a unicode string and returns it UTF-8 encoded.
 */
export function encodeAsUtf8(str) {
  return unescape(encodeURIComponent(str));
}

/**
 * Takes a unicode string and returns base64 encoding of its UTF-8 encoding.
 */

export function b64EncodeUnicode(str) {
  return btoa(encodeAsUtf8(str));
}
